import { render, staticRenderFns } from "./V3SlideDownTransition.vue?vue&type=template&id=3ada30fb"
var script = {}
import style0 from "./V3SlideDownTransition.vue?vue&type=style&index=0&id=3ada30fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports